(function () {
    "use strict";

    document.addEventListener("DOMContentLoaded", () => {
        const urlParams = new URLSearchParams(window.location.search);
        const noticeId = urlParams.get("noticeid");

        // 1. Handle auto-scrolling to specific notice ID on page load
        if (noticeId) {
            const noticePanel = document.getElementById(`Notice${noticeId}`);

            if (noticePanel) {
                let pos = noticePanel.getBoundingClientRect().top + window.scrollY;
                const mainNav = document.getElementById("main-nav-contents");

                // Adjust scroll target offset if navigation elements are fixed/visible
                if (mainNav && window.getComputedStyle(mainNav).display !== "none") {
                    const headerHeight = document.querySelector("header")?.offsetHeight || 0;
                    const breadcrumbHeight = document.querySelector(".breadcrumb-container")?.offsetHeight || 0;
                    pos -= headerHeight + breadcrumbHeight + 20;
                }

                window.scrollTo({
                    top: Math.max(0, pos),
                    behavior: "smooth"
                });
            }
        }

        // 2. Use Event Delegation on notice containers for click updates
        document.querySelectorAll(".notices").forEach(noticesContainer => {
            noticesContainer.addEventListener("click", (event) => {
                const link = event.target.closest(".notice a");
                if (!link) return;

                const noticeParent = link.closest(".notice");
                if (noticeParent?.id) {
                    const id = noticeParent.id.replace(/^Notice/, "");

                    const currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.set("noticeid", id);

                    window.history.pushState(null, "", currentUrl.toString());
                }
            });
        });
    });
})();